// pages/v1/system-setting/template-message.js
import React, { useEffect, useState } from "react";
import ProfileLayout from "./layout";
import { useMessageInvoice } from "contexts/v1/pages/MessageInvoiceContex"; // Update this path if necessary
import Swal from "sweetalert2";

const TemplateMessage = () => {
  const { messageInvoices, createMessageInvoice, refetch } =
    useMessageInvoice();

  const [formData, setFormData] = useState({
    message_notification_invoice: "",
  });

  useEffect(() => {
    if (messageInvoices && messageInvoices.data) {
      setFormData({
        message_notification_invoice:
          messageInvoices.data?.setting?.message_notification_invoice || "",
      });
    }
  }, [messageInvoices]);

  // Fungsi untuk menangani perubahan pada textarea
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Menyesuaikan tinggi textarea otomatis
    const textarea = e.target;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  // Fungsi untuk menangani tombol yang menambahkan placeholder teks
  const handleAddText = (text) => {
    setFormData((prevData) => {
      const newText = prevData.message_notification_invoice + text;
      return {
        ...prevData,
        message_notification_invoice: newText,
      };
    });
  };

  // Fungsi untuk mengirim form
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await createMessageInvoice(formData);
      if (response.success) {
        Swal.fire("Saved!", "Your changes have been saved.", "success");
        refetch();
      } else {
        Swal.fire("Error!", response.message, "error");
      }
    } catch (error) {
      Swal.fire("Error!", error.message, "error");
    }
  };

  // Placeholder buttons definition
  const placeholders = [
    { label: "Customer Name", value: "%customer_name%" },
    { label: "Invoice Name", value: "%invoice_name%" },
    { label: "Invoice Code", value: "%invoice_code%" },
    { label: "Due Date", value: "%invoice_due_date%" },
    { label: "Invoice Link", value: "%invoice_link%" },
    { label: "Grand Total", value: "%grand_total%" },
    { label: "Company Name", value: "%company_name%" },
    { label: "Company WhatsApp", value: "%company_whatsapp%" },
    { label: "Company Email", value: "%company_email%" },
  ];

  return (
    <ProfileLayout>
      <form onSubmit={handleSubmit}>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Invoice Notification</h2>
            <p className="ms-2 card-subtitle text-muted">
              Please enter your invoice notification message below.
            </p>
          </div>
          <div className="card-body">
            <div className="mb-3">
              <label
                htmlFor="message_notification_invoice"
                className="form-label"
              >
                Message
              </label>
              {/* Tombol untuk menambahkan placeholder ke textarea */}
              <div className="mt-3">
                {placeholders.map((placeholder) => (
                  <button
                    key={placeholder.value}
                    type="button"
                    className="btn btn-outline-teal m-2 btn-sm"
                    onClick={() => handleAddText(placeholder.value)}
                  >
                    {placeholder.label}
                  </button>
                ))}
              </div>
              <textarea
                className="form-control"
                id="message_notification_invoice"
                name="message_notification_invoice"
                placeholder="Enter your invoice notification message"
                value={formData.message_notification_invoice}
                onChange={handleChange}
                style={{
                  resize: "vertical", // Allow vertical resizing
                  overflow: "hidden", // Prevent scrollbars while resizing
                  minHeight: "200px", // Minimum height
                }}
              />
              <label className="form-label">
                Dengan menggunakan tanda % di awal dan akhir kata, maka kata
                tersebut akan diganti dengan data yang sesuai di invoice. Data
                yang tersedia adalah:
                {/* looping label pisahkan dengan tanda koma */}
                <p>
                  {placeholders.map((placeholder) => (
                    <span key={placeholder.value}>
                      {placeholder.label}
                      {placeholders.indexOf(placeholder) !==
                      placeholders.length - 1
                        ? ", "
                        : ""}
                    </span>
                  ))}
                </p>
              </label>
            </div>
          </div>
          <div className="card-footer text-end">
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </div>
      </form>
    </ProfileLayout>
  );
};

export default TemplateMessage;
